<template>
  <div>
    <label v-if="label" class="block text-base font-medium text-gray-700">
      {{ label }}
    </label>
    <div class="relative" :class="{ 'mb-8': invalid }">
      <input
        v-mask="showTimeSecond ? '##/##/#### ##:##:##' : '##/##/#### ##:##'"
        :value="value"
        :disabled="disabled"
        @input="updateValue"
        type="text"
        class="
          pr-10
          mt-1
          focus:ring-cyan-500 focus:border-cyan-500
          block
          w-full
          shadow-sm
          text-base
          border-gray-300
          rounded-md
          leading-none
        "
        :class="{ 'cursor-not-allowed text-gray-500': disabled }"
        :placeholder="
          showTimeSecond ? 'วว/ดด/ปปปป ชช:นน:วว' : 'วว/ดด/ปปปป ชช:นน'
        "
        @blur="onBlur"
      />
      <span v-if="invalid" class="absolute left-0 text-base text-red-600"
        >รูปแบบ วันที่และเวลา ไม่ถูกต้อง</span
      >
      <!-- clear button -->
      <button
        v-if="value"
        @click="clear"
        :disabled="disabled"
        type="button"
        :class="{ 'cursor-not-allowed': disabled }"
        class="absolute inset-y-0 right-10 focus:outline-none"
        tabindex="-1"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-gray-300 hover:text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
      <!-- end clear button -->
      <span class="absolute right-0.5 bottom-0.5">
        <button
          :disabled="disabled"
          @click="toggleDateTimePicker"
          type="button"
          class="group px-2 py-2 rounded-md focus:outline-none"
          :class="{ 'cursor-not-allowed': disabled }"
          tabindex="-1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-cyan-600 group-hover:text-cyan-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </button>
      </span>
      <span class="z-50 absolute bottom-12 shadow-xl">
        <DateTimePicker
          @input="updateValueDateTimePicker"
          :value="value"
          :showTimeSecond="showTimeSecond"
          v-on-clickaway="clickOutside"
          v-if="isShowDateTimePicker"
          @onChange="onChange"
        />
      </span>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import DateTimePicker from '@/components/DateTimePicker'
import moment from 'moment'

export default {
  mixins: [clickaway],

  components: {
    DateTimePicker,
  },

  props: {
    label: {
      type: String,
      default: '',
    },

    value: {
      type: [Date, String],
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    showTimeSecond: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isShowDateTimePicker: false,
      invalid: false,
    }
  },

  methods: {
    validateDatetime(value) {
      const format = this.showTimeSecond
        ? 'DD/MM/YYYY HH:mm:ss'
        : 'DD/MM/YYYY HH:mm'
      this.invalid = moment(value, format, false).isValid() ? false : true
    },

    onBlur() {
      if (this.value) {
        this.validateDatetime(this.value)
      }
      this.$emit('invalid', this.invalid)
    },

    onChange(type) {
      if (this.showTimeSecond && type === 'second') {
        this.isShowDateTimePicker = false
      }
      if (!this.showTimeSecond && type === 'minute') {
        this.isShowDateTimePicker = false
      }
    },

    clickOutside() {
      this.isShowDateTimePicker = false
    },

    toggleDateTimePicker() {
      this.isShowDateTimePicker = !this.isShowDateTimePicker
    },

    updateValue(event) {
      if (!event.target.value) {
        this.invalid = false
        this.$emit('invalid', this.invalid)
      }
      this.$emit('input', event.target.value)
    },

    updateValueDateTimePicker(value) {
      this.validateDatetime(value)
      this.$emit('invalid', this.invalid)
      this.$emit('input', value)
    },

    clear() {
      this.invalid = false
      this.$emit('invalid', this.invalid)
      this.$emit('input', '')
    },
  },
}
</script>
